/* global React, ReactDOM */
/* App raíz de for-business.html. Estaba incrustado dentro del HTML como
   <script type="text/babel">; se extrajo aquí para poder precompilarlo.
   Se carga DESPUÉS de ventas-sections.jsx, que publica window.CRMAPS_I18N
   y los componentes de sección en window. */
const { useState, useEffect } = React;
const APP_I18N = window.CRMAPS_I18N || {};
const getInitialLang = () => {
  try {
    const saved = window.localStorage.getItem("crmaps-lang");
    if (saved === "es" || saved === "en") return saved;
  } catch (err) {}
  return (navigator.language || "").toLowerCase().startsWith("es") ? "es" : "en";
};

function App() {
  const [activeSection, setActiveSection] = useState("");
  const [lang, setLang] = useState(getInitialLang);
  const copy = APP_I18N[lang] || APP_I18N.en;

  const changeLanguage = (nextLang) => {
    setLang(nextLang);
    try {
      window.localStorage.setItem("crmaps-lang", nextLang);
    } catch (err) {}
  };

  useEffect(() => {
    document.documentElement.lang = lang;
    document.title = copy.meta.title;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", copy.meta.description);
  }, [lang, copy]);

  useEffect(() => {
    const ids = ["ecosystem", "included", "pricing", "regions", "contact"];
    const els = ids.map((id) => document.getElementById(id)).filter(Boolean);
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) setActiveSection(entry.target.id);
      });
    }, { rootMargin: "-30% 0px -55% 0px" });
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <React.Fragment>
      <window.SalesNav activeSection={activeSection} lang={lang} onLanguageChange={changeLanguage} copy={copy} />
      <window.SalesHero copy={copy} />
      <window.Included copy={copy} />
      <window.PrintedPresence copy={copy} />
      <window.Pricing copy={copy} />
      <window.Regions copy={copy} />
      <window.Why copy={copy} />
      <window.SalesContact copy={copy} />
      <window.SalesFooter copy={copy} />
    </React.Fragment>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
